



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,Minus,Paperclip,Pencil,Plus,X} from 'lucide-react';
import NATInputTyper from "./NATInputTyper";
import DragMatch from "./DragDropBox";


  
const QueOptionsForResponse=({answerResponse,themeColor,questionType,setCurrentOption, element,index ,
    sectionName,lockTimeSent,id,setDeleteSectionPopUp})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemtitle, setItemtitle] = useState(sectionName); 
  


    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
     const [lockTime, setlockTime] = useState(lockTimeSent);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<>
  
   <div  onClick={()=>{answerResponse("answered")}}
   
   
   style={{padding:"10px",paddingBottom:"10px",margin:"5px", marginTop:"10px",borderRadius:"10px",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:questionType=="Drag Matching"?"":`3px solid ${themeColor?.color5}`}}> 
   
<div  style={{display:"flex",justifyContent:"left",gap:"10px"}}>
     
    <div>
    <div className="" style={{paddingRight:"50px"}}  > 
    
      <div
    //   style={{width:"50px",height:"40px",marginLeft:"-15px",position:"relative",
    //   borderRadius:"50%",
    //    alignContent:"center",textAlign:"center",padding:"5px",}}
       >
          {/* <GripVertical color="#958FDA" size={32} /> */}
          </div>  
          {element?.displayType=="textbox"?
      <div style={{display: "flex", flexWrap: "wrap",gap: "8px",alignItems:"center",lineHeight: "1.5",}} > <span>{index+1}</span>  
    {element?.optionBoxAlign=="right"? <span >{element?.optionText}</span>:""}
    
       <div className="selectOptionDropdown" style={{}}>
        <div className="" style={{marginTop:"0.5px",height:"20px",padding:"2px",margin:"3px",}}>
          {"Type Here" }
        </div></div>
         {element?.optionBoxAlign=="left"? <span >{element?.optionText}</span>:""}
        </div>:element?.displayType=="dropdown"?  <div style={{display: "flex", flexWrap: "wrap",gap: "8px",alignItems:"center",lineHeight: "1.5",}} >
       <span>{index+1}</span> 
        {element?.optionBoxAlign=="right"? <span >{element?.optionText}</span>:""}
       <div className="selectOptionDropdown" style={{}}>
        <div className="" style={{marginTop:"0.5px",height:"20px",padding:"2px",margin:"3px",}}>
          {"Choose" }
        </div>
        <div className="selectOptionDropdownInn" style={{}}>
          {element?.dropdownValues?JSON.parse(element?.dropdownValues)?.map((item, index) => 
        (<div className="selectOptionDropdownInnItem" style={{}}>
            <div className="" style={{margin:"0px",display:"grid",gridTemplateColumns:"40px auto",alignItems:"left"}}>
       {questionType=="MCQ"? <label className={"radio-outer"}>
                                 <input type={"radio"} title={element?.optionTitle}
                                                 className="input-textbox"  value={item?.choiceCorrect}
                                                  name={"optionTitle1"} checked= {item?.choiceCorrect}  onChange={e=>{  }}/>
                                                   <span class={"circle"}></span> </label>:
                                                   questionType=="MSQ"? <label className={"checkbox-outer"}>
                                 <input type={"checkbox"} title={element?.optionTitle}
                                                 className="input-textbox"  value={item?.choiceCorrect}
                                                  name={"optionTitle1"} checked= {item?.choiceCorrect}  onChange={e=>{  }}/>
                                                   <span class={"square"}></span> </label>
                                                   :questionType=="NAT"? <label className={"checkbox-outer"}>
                                 <input type={"checkbox"} title={element?.optionTitle}
                                                 className="input-textbox"  value={item?.choiceCorrect}
                                                  name={"optionTitle1"} checked= {item?.choiceCorrect}  onChange={e=>{  }}/>
                                                   <span class={"square"}></span> </label>:"" }
                                                    
                                                   
                                                    <div>{item?.optionTitle}</div></div>
        </div>
            

        )):""}  </div></div>
         {element?.optionBoxAlign=="left"? <span >{element?.optionText}</span>:""}
         </div> :<div className="" style={{margin:"0px",display:"grid",gridTemplateColumns:"15px 40px auto",alignItems:"left"}}>
            <span>{index+1}</span>    {questionType=="MCQ"||questionType=="True-False"?<label className={"radio-outer"} style={{marginTop:"-2px"}}>
                                 <input type={"checkbox"} title={element?.optionTitle}
                                                 className="input-textbox"  value={element?.isCorrect}
                                                  name={"optionTitle1"} checked= {element?.isCorrect=="true"?"yes":""}  onChange={e=>{  }}/>
                                                   <span class={"circle"}></span> </label>:questionType=="MSQ"?<label className={"checkbox-outer"} style={{marginTop:"-2px"}}>
                                 <input type={"checkbox"} title={element?.optionTitle}
                                                 className="input-textbox"  value={element?.isCorrect}
                                                  name={"optionTitle1"} checked= {element?.isCorrect=="true"?"yes":""}  onChange={e=>{  }}/>
                                                   <span class={"square"}></span> </label>:questionType=="NAT"?<div></div>:<div></div>} 
                                                   <div>{element?.optionText}   
                                                    {questionType=="NAT"?element?.isSingleRange=="false"?
                                                    " - Correct Answer is "+ element?.optionSingle:(element?.optionRange?JSON.parse(element?.optionRange)?.start?"- Correct Answer is Range Between ":"- Range Between 0":"")
                                                    +(element?.optionRange?JSON.parse(element?.optionRange)?.start:"")+" & "+(element?.optionRange?JSON.parse(element?.optionRange)?.end?JSON.parse(element?.optionRange)?.end:"0":""):""}
                                                    
      <div style={{display:"flex",justifyContent:"end"}}>{questionType=="NAT"?<NATInputTyper/>:""}</div>
                                                    
                    
                                                    </div></div>}
                                                    
        
        
        {/* let newOption= {
      ID: generateTimestamp(),
      questionType: "",
      optionText: "",
    optionImg: "",
    partialMarks: "",
    displayType: "",
    dropdownValues: "",
    isAllowPartialMarks: false,
    isCorrect: false,
    textBoxValue: ""
}; */}
        
        </div>
      
       
    
     
    </div>
    
    </div>
         {questionType=="Drag Matching"?<div style={{display:"flex",justifyContent:"center"}}><DragMatch element={element}  /></div>:""}                                
                       
    </div></>)
}  

export default QueOptionsForResponse;
